import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const UserIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M15.6666 16.5V14.8333C15.6666 13.9493 15.3154 13.1014 14.6903 12.4763C14.0652 11.8512 13.2173 11.5 12.3333 11.5H5.66658C4.78253 11.5 3.93468 11.8512 3.30956 12.4763C2.68444 13.1014 2.33325 13.9493 2.33325 14.8333V16.5M12.3333 4.83333C12.3333 6.67428 10.8409 8.16667 8.99992 8.16667C7.15897 8.16667 5.66658 6.67428 5.66658 4.83333C5.66658 2.99238 7.15897 1.5 8.99992 1.5C10.8409 1.5 12.3333 2.99238 12.3333 4.83333Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
